import { Image, Text, VStack } from "@chakra-ui/react"

import stackMatsnetBtcSuccessLogo from "#/assets/stack-matsnet-btc-success.svg"
import ModalContainer from "#/shared/components/ModalContainer"
import TooltipLabel from "#/shared/components/TooltipLabel"
import { useStackMatsnetBtcModal } from "#/shared/hooks"
import { MezoModalProps } from "#/shared/types"
import { networkUtils } from "#/shared/utils"

import StackMatsnetBtcModalBase from "./StackMatsnetBtcModalBase"
import StackMatsnetBtcSuccessModal from "./StackMatsnetBtcSuccessModal"

export default function StackMatsnetBtcModal({
  isOpen,
  onClose,
}: MezoModalProps) {
  const {
    displaySuccessModal,
    stackedSats,
    formatStackedSatsForSuccessModal,
    onSuccess,
    closeModal,
  } = useStackMatsnetBtcModal(onClose)

  return (
    <ModalContainer isOpen={isOpen} onClose={closeModal} width="522px">
      {displaySuccessModal ? (
        <StackMatsnetBtcSuccessModal>
          <VStack>
            <Image src={stackMatsnetBtcSuccessLogo} />
            <Text>Stacked</Text>
            <TooltipLabel
              value={`${stackedSats} sats`}
              props={{
                fontSize: "16px",
                rounded: "2px",
                placement: "right",
              }}
            >
              <Text
                color="primary.red.100"
                fontSize="80px"
                fontWeight={500}
                lineHeight="84px"
              >
                {formatStackedSatsForSuccessModal(stackedSats)}
              </Text>
            </TooltipLabel>
            <Text>{networkUtils.getMezoNetworkLabel()} sats.</Text>
          </VStack>
        </StackMatsnetBtcSuccessModal>
      ) : (
        <StackMatsnetBtcModalBase onSuccessCallback={onSuccess} />
      )}
    </ModalContainer>
  )
}
